import React from 'react'
import './styles.scss'
import prettysize from '../../../utils'
import lightBoltIcon from '../../../assets/logo/clock-simple.png'

export default ({ size }) => (
  <div className='download-size center-child indicator'>
    <span>Download Size</span>
    <div>
      <span>{prettysize(size)}</span>
      <img src={lightBoltIcon} />
    </div>
  </div>
)
